import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import * as heroApi from '../api/heroApi';

export const fetchActiveHero = createAsyncThunk(
  'hero/fetchActive',
  async (_, { rejectWithValue }) => {
    try {
      const data = await heroApi.fetchActiveHero();
      return data;
    } catch (err) {
      return rejectWithValue(err.message || 'Failed to fetch hero slide');
    }
  }
);

const heroSlice = createSlice({
  name: 'hero',
  initialState: {
    slide: null,
    loading: false,
    error: null,
  },
  reducers: {
    clearHeroError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchActiveHero.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchActiveHero.fulfilled, (state, action) => {
        state.loading = false;
        state.slide = action.payload;
      })
      .addCase(fetchActiveHero.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearHeroError } = heroSlice.actions;
export default heroSlice.reducer;
